import { render, staticRenderFns } from "./Professor-disciplina-search.vue?vue&type=template&id=886957ae&"
import script from "./Professor-disciplina-search.vue?vue&type=script&lang=js&"
export * from "./Professor-disciplina-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports